module.exports = __webpack_public_path__ + "static/media/how_it_works_confirmation_icon.0bfe9fd7.png";